import React from 'react';
import { RefreshCw, X } from 'lucide-react';
import { Button } from './ui/button';

/**
 * Update prompt banner that appears when a new version is available
 */
const UpdatePrompt = ({ onUpdate, onDismiss }) => {
  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 animate-in slide-in-from-bottom-4 duration-300">
      <div className="bg-gradient-to-r from-white to-blue-500 text-white rounded-lg shadow-2xl p-4 border border-white/30">
        <div className="flex items-start gap-3">
          <div className="bg-white/20 rounded-full p-2 flex-shrink-0">
            <RefreshCw size={20} className="animate-spin-slow" />
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="font-bold text-sm">Update Available</h4>
            <p className="text-xs text-white/80 mt-0.5">
              A new version of Doom Court is ready. Update now for the latest features!
            </p>
            <div className="flex gap-2 mt-3">
              <Button
                onClick={onUpdate}
                size="sm"
                className="bg-white text-zinc-400 hover:bg-white/90 font-bold text-xs h-8 px-4"
              >
                <RefreshCw size={14} className="mr-1" />
                Update Now
              </Button>
              <Button
                onClick={onDismiss}
                size="sm"
                variant="ghost"
                className="text-white/70 hover:text-white hover:bg-white/10 text-xs h-8"
              >
                Later
              </Button>
            </div>
          </div>
          <button 
            onClick={onDismiss}
            className="text-white/50 hover:text-white transition-colors flex-shrink-0"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePrompt;
